module.exports = __webpack_public_path__ + "img/remove-skill-star.ed454ea7.svg";